


































import Vue from 'vue'
import { mapState } from 'vuex'
import { SingleActions } from '@/shared/Actions'
import { connections } from '@/shared/socketApi'
import Spinner from '@/components/Spinner.vue'
import RoomStudentsForm from '@/components/in-room-registration/RoomStudentsForm.vue'
import RoomDynamicCard from '@/components/in-room-registration/RoomDynamicCard.vue'
import { api } from '@/shared/api'

export default Vue.extend({
  name: 'StudentRegistration',
  components: { RoomDynamicCard, RoomStudentsForm, Spinner },
  data: () => ({
    isUrlValid: false,
    hideFullRooms: false,
    sortBy: 'default'
  }),
  computed: {
    ...mapState({
      rooms: 'rooms',
      config: 'config'
    }),
    transformedRooms: function() {
      let rooms = [...this.rooms]
      if (this.hideFullRooms) {
        rooms = rooms.filter(room => room.students.length < room.size)
      }
      if (this.sortBy !== 'default') {
        rooms = rooms.sort((a, b) => {
          if (this.sortBy === 'available_places') {
            return b.size - b.students.length - (a.size - a.students.length)
          }
          return 0
        })
      }
      return rooms
    }
  },
  async mounted() {
    const result = await api.config.checkRegistrationUrl(this.$route.params.url)
    if (result.data.isValidRegistrationUrl) {
      this.isUrlValid = true
      this.$store.dispatch(SingleActions.FETCH_ALL_ROOMS)
      connections.roomUpdates.open()
      connections.reservationUpdates.open()
    } else {
      this.$router.push('/404')
    }
  },
  beforeDestroy() {
    connections.roomUpdates.close()
    connections.reservationUpdates.close()
  }
})
